import React from "react"
import { NavLink } from "widgets-for-react"

//  This function matches the url of a DrupalLink against a regex that checks if the url that we want to
//  navigat to is on the same host we are curently at, or is only a path so we can use the <Link> component
//  otherwhise, if it isnt a url on our own hostname it returns true and is external.
export type LinkProps = {
  kind: "link"
  isLinkExternal: boolean
  target: "_blank" | "_self"
  url: string
  title: string
}

const isLinkExternal = (link: string): boolean => {
  // debugger
  if (link && link != '' && !link.startsWith('/')) {
    let currentUrlHost = window.location.host

    if ((link.toLowerCase().includes("https://") || link.toLowerCase().includes("http://")) && new URL(link).host != currentUrlHost) {
      return true;
    }

    return false;

    // let pattern = RegExp(`(http|https:\/\/(!?${currentUrlHost}/.*)|^\/.*)`, "gm");
    // const isExternal = !pattern.test(link);
    // return isExternal;
  } else {
    return false
  }
}

export const stripUrlToPath = (link: { title: string, url: string }): string => {
  let a = document.createElement("a")
  a.href = link.url
  return a.pathname
}

export const linkWrapper = (rawLink: { title: string, url: string }): LinkProps => {
  const path = rawLink.url && stripUrlToPath(rawLink)
  const link = path.startsWith("/sites/") || isLinkExternal(rawLink.url) ? rawLink : { ...rawLink, url: path }
  return ({
    kind: "link",
    isLinkExternal: isLinkExternal(link.url),
    target: isLinkExternal(link.url) ? "_blank" : "_self",
    title: link.title,
    url: isLinkExternal(link.url) ? link.url : stripUrlToPath(link),
  })
}

export function link(
  link: LinkProps,
  style: { classname: string },
  inner: JSX.Element | string,
  action: () => void = () => { }
): JSX.Element {
  return isLinkExternal(link.url) || link.target === '_blank' ? (
    <a
      className={style.classname}
      target={link.target}
      href={link.url}
      rel={link.target === '_blank' ? 'noopener noreferrer' : ''}
    >
      {inner}
    </a>
  ) : (
    <NavLink
      to={link.url}
      title={link.title}
      className={style.classname}
      onClick={() => action()}
    >
      {link.title}
    </NavLink>
  )
}

